// src/config/urls.js
// Centralized URL and endpoint management for all environments
//
// Usage:
//   - Import { API_BASE_URL, FRONTEND_BASE_URL, API_ENDPOINTS } from this file in all components and utilities.
//   - Do NOT hardcode URLs or endpoints elsewhere in the codebase.
//   - Add new endpoints or environment URLs here as needed.
//
// Example:
//   import { API_BASE_URL, API_ENDPOINTS } from '../config/urls';
//   axios.get(API_ENDPOINTS.TICKET_VALIDITY, { baseURL: API_BASE_URL });

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8080";
export const FRONTEND_BASE_URL = process.env.REACT_APP_FRONTEND_BASE_URL || "http://localhost:3000";

export const API_ENDPOINTS = {
  TICKET_VALIDITY: "/documents/ticket/validity",
  UPLOAD: "/documents/upload",
  UPLOAD_MULTIPLE: "/documents/upload-multiple",
  CLOSE_PAY: "/documents/ticket/close-pay",
  TOKEN_GENERATE: "/documents/token/generate",
  TOKEN_VALIDATE: "/documents/token/validate",
  // Add more endpoints here as needed
};
